import * as z from "zod";

export const editCustomerFormSchema = z.object({
  company_name: z.string().min(1, "Please enter company name."),
  website: z.string().optional(),
  company_phone: z.string().optional(),
  company_email: z
    .email("Please enter a valid email.")
    .min(1, "Please enter company email."),
  company_street_address: z.string().optional(),
  company_country_id: z.string().min(1, "Please select country."),
  company_state_id: z.string().min(1, "Please select state."),
  company_city_id: z.string().min(1, "Please select city."),
  company_postal_code: z.string().optional(),
  tax_id: z.string().optional(),
});

export type EditCustomerFormValues = z.infer<typeof editCustomerFormSchema>;
